import axios from '../axios';
const END_POINT = '/web-service-versions';

const getWebServiceVersions = () => axios.get(`${END_POINT}`);
export {
    getWebServiceVersions,
}